<template>
  <div class="content-wrapper is-fluid">
    <MenuBar>
      <BookmarksFilterBar :selected-tags="selectedTags" />
    </MenuBar>

    <template v-if="!user.isNew">
      <BookmarksList />
    </template>
    <template v-else>
      <InfoPanel />
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MenuBar from "@/views/_globals/MenuBar.vue"
  import BookmarksFilterBar from "@/components/bookmarks/BookmarksFilterBar.vue"
  import BookmarksList from '@/components/bookmarks/BookmarksList.vue'
  import InfoPanel from '@/components/shared/InfoPanel.vue'

  export default {
    name: 'Bookmarks',
    components: {
      MenuBar,
      BookmarksFilterBar,
      BookmarksList,
      InfoPanel
    },
    data: function() {
      return {
        selectedTags: [],
      }
    },
    mounted() {
      if (this.user.isNew == true) {
        this.$store.dispatch('auth/reloadLogin')
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        logged: 'auth/logged'
      })
    },
  }
</script>

<style lang="scss" scoped>
</style>
